module.exports = __webpack_public_path__ + "assets/img/timeline__img-2.cdeb3109.svg";